const newPalette = {
  content: {
    light: {
      primary: '#172125',
      secondary: '#5C6C73',
      tertiary: '#7D9199',
      inactive: '#B4C5CC',
    },
    dark: {
      primary: '#ffffff',
      secondary: '#5C6C73',
      tertiary: '#667880',
      inactive: '#415259',
    },
    gray: {
      primary: '#172125',
      secondary: '#5C6C73',
      tertiary: '#7D9199',
      inactive: '#B4C5CC',
    },
    colored: {
      primary: '#ffffff',
      secondary: 'rgba(255, 255, 255, 0.70)',
      tertiary: 'rgba(255, 255, 255, 0.40)',
      inactive: 'rgba(255, 255, 255, 0.40)',
    },
  },

  action: {
    light: {
      primary: '#0079BF',
      primaryHover: '#006CA6',
      visited: '#004D73',
      secondary: '#172125',
      secondaryHover: '#0079BF',
      brand: '#FA4616',
      brandHover: '#C2320C',
      disabled: '#B4C5CC',
      labelPrimary: '#FFFFFF',
      labelSecondary: '#FFFFFF',
      labelTertiary: '#172125',
    },
    dark: {
      primary: '#2198D9',
      primaryHover: '#0079BF',
      visited: '#005E8C',
      secondary: '#FFFFFF',
      secondaryHover: '#FFFFFF',
      brand: '#FA4616',
      brandHover: '#C2320C',
      disabled: '#4F5F66',
      labelPrimary: '#FFFFFF',
      labelSecondary: '#172125',
      labelTertiary: '#FFFFFF',
    },
    gray: {
      primary: '#0079BF',
      primaryHover: '#006CA6',
      visited: '#004D73',
      secondary: '#172125',
      secondaryHover: '#0079BF',
      brand: '#FA4616',
      brandHover: '#C2320C',
      disabled: '#BDBFBF',
      labelPrimary: '#FFFFFF',
      labelSecondary: '#FFFFFF',
      labelTertiary: '#172125',
    },
    colored: {
      primary: '#FFFFFF',
      primaryHover: '#FFFFFF',
      visited: 'rgba(255, 255, 255, 0.70)',
      secondary: 'rgba(255, 255, 255, 0.80)',
      secondaryHover: '#FFFFFF',
      brand: '#FFFFFF',
      brandHover: '#FFFFFF',
      disabled: 'rgba(255, 255, 255, 0.40)',
      labelPrimary: '#172125',
      labelSecondary: '#FFFFFF',
      labelTertiary: '#172125',
    },
  },
  feedback: {
    light: {
      error: '#F5222D',
      warning: '#FFB40E',
      success: '#31D263',
    },
    dark: {
      error: '#F5222D',
      warning: '#FFB40E',
      success: '#31D263',
    },
    gray: {
      error: '#F5222D',
      warning: '#FFB40E',
      success: '#31D263',
    },
    colored: {
      error: '#A6040A',
      warning: '#FFB40E',
      success: '#74F09B',
    },
  },
  border: {
    light: {
      strong: '#202E33',
      firm: '#8A9EA6',
      normal: '#A3B7BF',
      subtle: '#D5E3E8',
      faint: '#E4F0F5',
    },
    dark: {
      strong: '#E4F0F5',
      firm: '#8A9EA6',
      normal: '#8A9EA6',
      subtle: '#415259',
      faint: '#293940',
    },
    gray: {
      strong: '#202E33',
      firm: '#8A9EA6',
      normal: '#A3B7BF',
      subtle: '#C3D3D9',
      faint: '#D5E3E8',
    },
    colored: {
      strong: '#FFFFFF',
      firm: 'rgba(255, 255, 255, 0.40)',
      normal: 'rgba(255, 255, 255, 0.30)',
      subtle: 'rgba(255, 255, 255, 0.20)',
      faint: 'rgba(255, 255, 255, 0.10)',
    },
  },

  background: {
    light: {
      default: '#ffffff',
      accent: '#F0F9FC',
      inverted: '#202E33',
      brand: '#FA4616',
    },
    dark: {
      default: '#172125',
      accent: '#293940',
      inverted: '#FFFFFF',
      brand: '#FA4616',
    },
    gray: {
      default: '#F0F9FC',
      accent: '#D5E3E8',
      inverted: '#202E33',
      brand: '#FA4616',
    },
    colored: {
      default: '#FA4616',
      accent: 'rgba(255, 255, 255, 0.20)',
      inverted: '#FFFFFF',
      brand: '#FFFFFF',
    },
  },

  button: {
    light: {
      primary: '#FA4616',
      primaryHover: '#C2320C',
      primaryPressed: '#DC4226',
      primaryDisabled: 'rgba(23, 33, 37, 0.20)',
      secondary: '#293940',
      secondaryHover: '#172125',
      secondaryPressed: '#35464D',
      secondaryDisabled: 'rgba(23, 33, 37, 0.20)',
      tertiary: 'transparent',
      tertiaryHover: 'rgba(23, 33, 37, 0.20)',
      tertiaryPressed: 'rgba(23, 33, 37, 0.20)',
      tertiaryDisabled: 'transparent',
    },
    dark: {
      primary: '#FA4616',
      primaryHover: '#C2320C',
      primaryPressed: '#DC4226',
      primaryDisabled: 'rgba(255, 255, 255, 0.20)',
      secondary: '#E4F0F5',
      secondaryHover: '#FFFFFF',
      secondaryPressed: '#D5E3E8',
      secondaryDisabled: 'rgba(255, 255, 255, 0.20)',
      tertiary: 'transparent',
      tertiaryHover: 'rgba(255, 255, 255, 0.20)',
      tertiaryPressed: 'rgba(255, 255, 255, 0.20)',
      tertiaryDisabled: 'transparent',
    },
    gray: {
      primary: '#FA4616',
      primaryHover: '#C2320C',
      primaryPressed: '#DC4226',
      primaryDisabled: 'rgba(23, 33, 37, 0.20)',
      secondary: '#293940',
      secondaryHover: '#172125',
      secondaryPressed: '#35464D',
      secondaryDisabled: 'rgba(23, 33, 37, 0.20)',
      tertiary: 'transparent',
      tertiaryHover: 'rgba(23, 33, 37, 0.20)',
      tertiaryPressed: 'rgba(23, 33, 37, 0.20)',
      tertiaryDisabled: 'transparent',
    },
    colored: {
      primary: 'rgba(255, 255, 255, 0.90)',
      primaryHover: '#FFFFFF',
      primaryPressed: 'rgba(255, 255, 255, 0.70)',
      primaryDisabled: 'rgba(255, 255, 255, 0.20)',
      secondary: 'rgba(23, 33, 37, 0.80)',
      secondaryHover: '#172125',
      secondaryPressed: 'rgba(23, 33, 37, 0.70)',
      secondaryDisabled: 'rgba(255, 255, 255, 0.20)',
      tertiary: 'transparent',
      tertiaryHover: 'rgba(255, 255, 255, 0.20)',
      tertiaryPressed: 'rgba(255, 255, 255, 0.20)',
      tertiaryDisabled: 'transparent',
    },
  },

  orange: {
    10: '#FEE3DC',
    20: '#FDA891',
    30: '#FC7753',
    40: '#FB5124',
    50: '#FA4616',
    60: '#DC4226',
    70: '#C2320C',
    80: '#832107',
    90: '#400F02',
  },
  deepBlue: {
    5: '#F2FAFC',
    10: '#E4F0F5',
    15: '#D5E3E8',
    20: '#C3D3D9',
    25: '#B4C5CC',
    30: '#A3B7BF',
    35: '#96AAB2',
    40: '#8A9EA6',
    45: '#7D9199',
    50: '#73858C',
    55: '#667880',
    60: '#5C6C73',
    65: '#4F5F66',
    70: '#415259',
    75: '#35464D',
    80: '#293940',
    85: '#202E33',
    90: '#172125',
  },
  teal: {
    10: '#CEECF0',
    20: '#9DDAE1',
    30: '#57C5D1',
    40: '#24AFBF',
    50: '#0BA2B3',
    60: '#078E9E',
    70: '#087885',
    80: '#055159',
    90: '#032E33',
  },
  brightBlue: {
    10: '#D6F3FF',
    20: '#97E0FC',
    30: '#53BCED',
    40: '#2198D9',
    50: '#0079BF',
    60: '#006CA6',
    70: '#005E8C',
    80: '#004D73',
    90: '#003C59',
  },
  gray: {
    5: '#F5F6F7',
    10: '#EDEFF0',
    15: '#E3E5E5',
    20: '#D7D8D9',
    25: '#CACBCC',
    30: '#BDBFBF',
    35: '#B1B2B3',
    40: '#A4A5A6',
    45: '#979899',
    50: '#7E7F80',
    55: '#727273',
    60: '#656666',
    65: '#585959',
    70: '#4C4C4D',
    75: '#3F4040',
    80: '#323333',
    85: '#262626',
    90: '#19191A',
  },

  alphaBlack: {
    10: 'rgba(23, 33, 37, 0.10)',
    20: 'rgba(23, 33, 37, 0.20)',
    30: 'rgba(23, 33, 37, 0.30)',
    40: 'rgba(23, 33, 37, 0.40)',
    50: 'rgba(23, 33, 37, 0.50)',
    60: 'rgba(23, 33, 37, 0.60)',
    70: 'rgba(23, 33, 37, 0.70)',
    80: 'rgba(23, 33, 37, 0.80)',
  },

  alphaWhite: {
    10: 'rgba(255, 255, 255, 0.10)',
    20: 'rgba(255, 255, 255, 0.20)',
    30: 'rgba(255, 255, 255, 0.30)',
    40: 'rgba(255, 255, 255, 0.40)',
    50: 'rgba(255, 255, 255, 0.50)',
    60: 'rgba(255, 255, 255, 0.60)',
    70: 'rgba(255, 255, 255, 0.70)',
    80: 'rgba(255, 255, 255, 0.80)',
  },

  white: '#ffffff',
  black: '#172125',
}
export default newPalette
